import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute} from '@angular/router';
import {isNullOrUndefined} from "util";
import {canChangeValue} from "ngx-bootstrap/timepicker/timepicker-controls.util";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
              private route: ActivatedRoute) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    try {
      const user = localStorage.getItem('currentUser');
      if (!isNullOrUndefined(user)) {
        const roles = route.data.roles;
        if (this.checkRoles(roles, JSON.parse(user).roles)) {
          // logged in so return true
          return true;
        }
      }
    } catch (e) {
    }

    const alias = localStorage.getItem("organizationAlias");
    // not logged in so redirect to login page with the return url
    console.log("AUTh!! ", alias);

    this.router.navigate(['/' + alias + '/login'],
      {queryParams: {returnUrl: state.url}});

    return false;
  }

  private checkRoles(routeRoles: any[], userRoles: any[]): boolean {

    return !isNullOrUndefined(
      routeRoles.find((value, index, obj) => {
        return userRoles.includes(value);
      })
    );
  }
}





// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_guards/auth.guard.ts